var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"display":"inline-block"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('Avatar',{attrs:{"src":_vm.UserAvatarSrc}}),_c('a',{staticStyle:{"color":"inherit"},attrs:{"href":"javascript:void(0)"}},[_vm._v(" "+_vm._s(_vm.userName)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }